<ng-container *uiModernContext>
    <mat-tab-group matDialogTitle
                   dynamicHeight="true"
                   class="tab-header">
        <mat-tab #generalTab
                 [label]="'users_grid_action_import' | translate">
        </mat-tab>
        <mat-tab #settingsTab
                 [label]="'user_modal_title_robot_settings' | translate">
        </mat-tab>
    </mat-tab-group>
</ng-container>

<ng-container *uiLegacyContext>
    <h1 [translate]="'users_grid_action_import' | translate"
        matDialogTitle></h1>
</ng-container>

<form [formGroup]="form"
      (submit)="onSubmit()">
    <mat-dialog-content>
        <section [hidden]="generalTab != null &&
                           !generalTab.isActive">
            <ui-ad-search (isLoading)="isAdSearchLoading = $event"></ui-ad-search>

            <ng-container *ngIf="!isAdSearchLoading">
                <mat-form-field>
                    <ui-suggest [multiple]="true"
                                [placeholder]="'user_import_modal_form_roles' | translate"
                                [defaultValue]="'user_import_modal_form_roles_empty' | translate"
                                [searchSourceFactory]="roleSearchFactory"
                                [formControlName]="UserGroupField.Roles"
                                [displayCount]="5"
                                direction="up">
                    </ui-suggest>
                </mat-form-field>

                <mat-slide-toggle *uiModernContext
                                  [formControlName]="UserGroupField.MayHaveUserSession">
                    <span translate>user_modal_robot_may_have_user_session</span>
                </mat-slide-toggle>
            </ng-container>
        </section>

        <ng-container *uiModernContext>
            <section *ngLet="form.get(UserGroupField.UserName)?.value as selectedUser"
                     [hidden]="!settingsTab?.isActive">
                <ng-container *ngIf="selectedUser && selectedUser[0]; else noUserSelected">
                    <mat-slide-toggle *ngLet="isRobotSwitcherEnabled$ | async as isRobotSwitcherEnabled"
                                      [disabled]="!isRobotSwitcherEnabled"
                                      [matTooltip]="isRobotSwitcherEnabled ? '' : ('authorize_no_permissions' | translate)"

                                      [formControlName]="UserGroupField.MayHaveRobotSession"
                                      class="may-have-robot-switch">

                        <span *ngIf="form.get(UserGroupField.Type)!.value !== UserType.DirectoryGroup; else autoProvisionGroup"
                              translate>
                            user_modal_robot_autoprovision_user
                        </span>
                        <ng-template #autoProvisionGroup>
                            <span translate>user_modal_robot_autoprovision_group</span>
                        </ng-template>

                    </mat-slide-toggle>

                    <ui-user-provision-robot [enabled]="form.get(UserGroupField.MayHaveRobotSession)!.value"
                                             [userType]="form.get(UserGroupField.Type)!.value">
                    </ui-user-provision-robot>
                </ng-container>
                <ng-template #noUserSelected>
                    <span translate>user_modal_robot_autoprovision_no_user_selected</span>
                </ng-template>
            </section>
        </ng-container>

    </mat-dialog-content>

    <mat-dialog-actions *ngLet="{
                            loading: loading$ | async
                        } as state"
                        align="end">
        <button mat-dialog-close
                mat-button
                type="button">
            {{ 'modal_action_cancel' | translate }}
        </button>
        <button [spinnerButtonLoading]="state.loading"
                [disabled]="state.loading ||
                        form.invalid"
                ui-spinner-button
                mat-flat-button
                type="submit"
                color="primary">
            {{ 'generic_action_add' | translate }}
        </button>
    </mat-dialog-actions>

</form>
